import BlogImage1 from 'images/news/blogs/solitaire-clash-moms-week-with-love/1.webp'
import BlogImage10 from 'images/news/blogs/solitaire-clash-moms-week-with-love/10.webp'
import BlogImage11 from 'images/news/blogs/solitaire-clash-moms-week-with-love/11.webp'
import BlogImage12 from 'images/news/blogs/solitaire-clash-moms-week-with-love/12.webp'
import BlogImage2 from 'images/news/blogs/solitaire-clash-moms-week-with-love/2.webp'
import BlogImage3 from 'images/news/blogs/solitaire-clash-moms-week-with-love/3.webp'
import BlogImage4 from 'images/news/blogs/solitaire-clash-moms-week-with-love/4.webp'
import BlogImage5 from 'images/news/blogs/solitaire-clash-moms-week-with-love/5.webp'
import BlogImage6 from 'images/news/blogs/solitaire-clash-moms-week-with-love/6.webp'
import BlogImage7 from 'images/news/blogs/solitaire-clash-moms-week-with-love/7.webp'
import BlogImage8 from 'images/news/blogs/solitaire-clash-moms-week-with-love/8.webp'
import BlogImage9 from 'images/news/blogs/solitaire-clash-moms-week-with-love/9.webp'
import CoverImage from 'images/news/blogs/solitaire-clash-moms-week-with-love/cover.webp'
import { joinDomain } from '../../../utils'
import { GameType } from '../../games'
import { NewsCategory, NewsItem } from '../home'
import { SolitaireClashMomsWeekWithLoveRoute } from '../route'
import { BlogData, BlogModule } from './const'

export const SolitaireClashMomsWeekWithLove: BlogData = {
  key: 'solitaire-clash-moms-week-with-love',
  title: 'Mom’s Week Recap: How Solitaire Clash Celebrated Mother’s Day 2025 with Players Worldwide',
  tag: NewsCategory.GameEvents,
  date: 'Aug 01, 2025',
  game: GameType.SolitaireClash,
  content: [
    {
      type: BlogModule.Paragraph,
      value: (
        <>
          Mother’s Day 2025 marked a significant milestone for Solitaire Clash as we launched our very first integrated
          brand campaign: <strong>Mom’s Week</strong>. More than just a themed event, it was a heartfelt celebration of
          love, family, and connection—values deeply embedded in our game and community.
          <br />
          <br />
          This campaign brought together in-game interactions, livestreaming, offline engagement, and user-generated
          stories into one cohesive experience. Our goal was to move beyond the binary of win or lose and to position
          Solitaire Clash as a brand with heart. And we did just that, with measurable impact and emotional resonance
          that echoed across digital and real-world spaces.
          <br />
          <br />
          Below is a full breakdown of the campaign initiatives, highlights, and achievements.
        </>
      ),
    },
    {
      type: BlogModule.Title,
      value: <>In-Game Seven-Day Check-In and Holiday Items</>,
    },
    {
      type: BlogModule.Paragraph,
      value: (
        <>
          We kicked off the campaign by transforming the in-game experience into something truly meaningful for Mother’s
          Day. For the first time, Solitaire Clash connected gameplay directly to the community through a{' '}
          <strong>seven-day login event</strong> featuring holiday-themed rewards and heartfelt messages.
          <br />
          <br />
          Players who logged in each day were greeted with <strong>exclusive Mother’s Day greetings</strong> and{' '}
          <strong>limited-edition items</strong>—such as themed card designs, a festive table layout, and a
          commemorative avatar frame—creating a warm, celebratory atmosphere from the moment they opened the app.
          <br />
          <br />
          What stood out was not just the volume of participation, but the sentiment from our community: “This is the
          first time a mobile game made me feel like I was celebrating the holiday.”
          <br />
          <br />
          The numbers speak to the success:
          <ul className="my-3 list-disc">
            <li>
              Over <strong>100,000 holiday greetings</strong> delivered in-app
            </li>
            <li>
              More than <strong>9,000 player responses</strong> expressing gratitude or emotional reflection
            </li>
            <li>
              A total of <strong>1,800 holiday-themed items</strong> redeemed during the activation period
            </li>
          </ul>
          This kickoff event set the emotional tone for the entire campaign, emphasizing care, recognition, and the
          human stories behind each player.
        </>
      ),
    },
    {
      type: BlogModule.Title,
      value: <>Mother&#39;s Day Wish List</>,
    },
    {
      type: BlogModule.Image,
      value: {
        image: BlogImage1,
      },
    },
    {
      type: BlogModule.Paragraph,
      value: (
        <>
          At the heart of “Mom’s Week” was the <strong>Wish List Activity</strong>, a campaign component that gave our
          players a voice, and gave us the opportunity to respond with action. <br />
          <br />
          We invited players from around the world to submit their most heartfelt wishes. In just a few days, we
          received <strong>over 2,000 submissions</strong>, each representing a deeply personal moment or hope. <br />
          <br />
          Among these stories, several stood out for their sincerity and emotional weight.
        </>
      ),
    },
    {
      type: BlogModule.Subtitle,
      value: <>A mother seeking a new helmet for her son who uses a wheelchair for off-road racing</>,
    },
    {
      type: BlogModule.Image,
      value: {
        image: BlogImage2,
      },
    },
    {
      type: BlogModule.Subtitle,
      value: (
        <>
          A player who wanted to buy a meal or a gift card for a homeless individual they see regularly, as a way of
          expressing “someone cares about you in this world”
        </>
      ),
    },
    {
      type: BlogModule.Image,
      value: {
        image: BlogImage3,
      },
    },
    {
      type: BlogModule.Paragraph,
      value: (
        <>
          These were not just wishes. They were windows into the lives of our players—real people facing real
          challenges, hopes, and moments of love. We selected <strong>30 wishes</strong> to fulfill, and in doing so,
          helped create lasting memories that extended far beyond the screen.
          <br />
          <br />
          This initiative reminded us that while our game may be digital, the connections we form through it are very
          real. Solitaire Clash became more than a game—it became a platform for empathy and generosity.
        </>
      ),
    },
    {
      type: BlogModule.Title,
      value: <>Livestream Experience</>,
    },
    {
      type: BlogModule.Image,
      value: {
        image: BlogImage4,
      },
    },
    {
      type: BlogModule.Paragraph,
      value: (
        <>
          Building on the emotional resonance of the in-game and wish list experiences, we hosted a{' '}
          <strong>livestream</strong> that redefined how a mobile game can connect with its audience. Themed “
          <strong>Memories and Celebrations</strong>,” the event featured original music from The Band McMillan,
          interactive mini-game challenges, and real-time player shoutouts and engagement.
        </>
      ),
    },
    {
      type: BlogModule.Image,
      value: {
        image: BlogImage5,
      },
    },
    {
      type: BlogModule.Paragraph,
      value: (
        <>
          The livestream wasn’t just a commercial presentation—it was a genuine community celebration. For the first
          time, many players commented that they truly felt seen by the brand. Feedback included remarks such as:
          <br />
          <br />
          “I didn’t know a game company could create something this personal.”
          <br />
          <br />
          “It felt like a real Mother’s Day party.”
        </>
      ),
    },
    {
      type: BlogModule.Image,
      value: {
        image: BlogImage6,
      },
    },
    {
      type: BlogModule.Paragraph,
      value: (
        <>
          The livestream drew an impressive audience, with over 3,200 viewers tuning in at its peak. Throughout the
          event, we saw more than 28,000 real-time interactions, ranging from heartfelt messages to reactions and
          enthusiastic participation in mini-game challenges. But beyond the numbers, what truly stood out was the
          emotional connection we built. This wasn’t just a broadcast; it became a shared experience that brought
          players closer to the brand in a genuine and lasting way. It marked a turning point in how we can use
          livestreams, not just as promotional tools, but as platforms for community and celebration.
        </>
      ),
    },
    {
      type: BlogModule.Title,
      value: <>Milk Tea Shop Pop-Up Event in Los Angeles</>,
    },
    {
      type: BlogModule.Image,
      value: {
        image: BlogImage7,
      },
    },
    {
      type: BlogModule.Paragraph,
      value: (
        <>
          To bring the warmth of the campaign into the real world, we launched an offline collaboration with{' '}
          <strong>XFT Milk Tea</strong>, a popular boba shop in Los Angeles.
          <br />
          <br />
          On May 17, Solitaire Clash brought its first-ever offline community event to life through a special
          collaboration with XFT Milk Tea in Los Angeles. The shop was transformed into a festive gathering space,
          complete with custom holiday-themed milk tea drinks, limited-edition Mother&#39;s Day cup sleeves, and a
          playful “clock-in mission” that encouraged guests to take photos, share personal stories, and connect with our
          team in person.
        </>
      ),
    },
    {
      type: BlogModule.Image,
      value: {
        image: BlogImage8,
      },
    },
    {
      type: BlogModule.Paragraph,
      value: (
        <>
          The response was overwhelming. A large and enthusiastic crowd joined us, and some brought their children,
          others came with friends, and many took the opportunity to meet the faces behind Solitaire Clash for the first
          time. Throughout the day, the venue buzzed with laughter, heartfelt conversations, and spontaneous moments of
          connection. What began as a branded activation quickly evolved into something more: a space where players
          could celebrate, reminisce, and feel part of a larger community.
        </>
      ),
    },
    {
      type: BlogModule.Image,
      value: {
        image: BlogImage9,
      },
    },
    {
      type: BlogModule.Image,
      value: {
        image: BlogImage10,
      },
    },
    {
      type: BlogModule.Image,
      value: {
        image: BlogImage11,
      },
    },
    {
      type: BlogModule.Paragraph,
      value: (
        <>
          One attendee put it best: “I never thought a mobile game would make me feel so connected in real life.” That
          single line captured the spirit of the day. More than a marketing moment, this event was a meaningful
          extension of the warmth our brand strives to bring—proving that even in a digital-first world, real-world
          experiences still hold incredible power.
        </>
      ),
    },
    {
      type: BlogModule.Title,
      value: <>Achievements, Teamwork, and the Road Ahead</>,
    },
    {
      type: BlogModule.Image,
      value: {
        image: BlogImage12,
      },
    },
    {
      type: BlogModule.Paragraph,
      value: (
        <>
          What made “Mom’s Week” truly stand out wasn’t just the individual moments. It was how everything came together
          to create something greater and more personal. We invited players into a shared experience, and they responded
          with real stories, genuine emotion, and a sense of connection that extended beyond the game. This wasn’t just
          a campaign; it was a reflection of how Solitaire Clash is becoming a meaningful part of players’ lives.
          <br />
          <br />
          A sincere thank you to everyone who made it possible! From marketing and community to design, operations,
          business development, livestream, and every team in between, this was a collective achievement. Your
          creativity, coordination, and attention to detail shaped an experience that resonated deeply with our players.
          <br />
          <br />
          This is only the beginning. “Mom’s Week” proved the power of thoughtful, emotionally driven campaigns. Let’s
          keep building on this momentum and continue creating moments that feel personal, lasting, and truly impactful!
        </>
      ),
    },
  ],
  more: [],
  path: joinDomain(SolitaireClashMomsWeekWithLoveRoute),
}

export const SolitaireClashMomsWeekWithLoveNews: NewsItem = {
  id: 17,
  image: CoverImage,
  breadcrumb: [SolitaireClashMomsWeekWithLove.tag, SolitaireClashMomsWeekWithLove.date],
  title: SolitaireClashMomsWeekWithLove.title,
  url: SolitaireClashMomsWeekWithLove.path,
}
